module.exports = __webpack_public_path__ + "media/SndType.344a75ce.mp3";